import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

import "bootstrap/dist/css/bootstrap.min.css";
import "font-awesome/css/font-awesome.min.css";
import router from "./router";

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
